export const MIN_GPA_VALUE = 0;
export const MAX_UNWEIGHTED_GPA_VALUE = 125;
export const MAX_WEIGHTED_GPA_VALUE = 125;

export const MIN_ACT_VALUE = 1;
export const MAX_ACT_VALUE = 36;

export const MIN_SAT_VALUE = 200;
export const MAX_SAT_VALUE = 1600;
export const MIN_SAT_SUB_VALUE = 200;
export const MAX_SAT_SUB_VALUE = 800;

export const MAX_PSAT_VALUE = 1520;
export const MIN_PSAT_SUB_VALUE = 160;
export const MAX_PSAT_SUB_VALUE = 760;

export const WRITING_SCORE_VALUE = 12;

export const TEST_TYPES = {
  SAT: 'satCompositeScore',
  ACT: 'actCompositeScore',
};

export const GPA_TYPES = {
  weighted: 'weightedGpa',
  unweighted: 'unweightedGpa',
};
